// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 524) return "static/chunks/524-31b61ad9b0bf5a74.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"314":"05950614ce6ad593","541":"2efce13b40c3297c","664":"5b40b500ff3cde49","858":"c7a328eabd4a32ee","994":"b6ddbe24cf9cf7a9"}[chunkId] + ".js";
};